var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        fill: "#F09A0FFF",
        version: "1.1",
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        viewBox: "0 0 512 512",
        "xml:space": "preserve",
        width: "20px",
        height: "20px",
      },
    },
    [
      _c("g", { attrs: { id: "SVGRepo_bgCarrier", "stroke-width": "0" } }),
      _vm._v(" "),
      _c("g", {
        attrs: {
          id: "SVGRepo_tracerCarrier",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _vm._v(" "),
      _c("g", { attrs: { id: "SVGRepo_iconCarrier" } }, [
        _c("g", [
          _c("g", [
            _c("path", {
              attrs: {
                d: "M0.214,96.347V416.08h511.573V96.347H0.214z M495.799,400.094H16.2v-31.288h192.087V353.09h-23.173 c3.014-9.8,12.15-16.943,22.925-16.943h95.92c10.775,0,19.911,7.143,22.925,16.943h-23.253v15.716h192.168V400.094z M495.8,353.09 H343.293c-3.336-18.692-19.699-32.93-39.334-32.93H208.04c-19.636,0-35.997,14.238-39.333,32.93H16.2V112.334H495.8V353.09z",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("rect", {
              attrs: {
                x: "224.008",
                y: "353.09",
                width: "63.912",
                height: "15.716",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("path", {
              attrs: {
                d: "M255.999,136.314c-48.482,0-87.927,39.443-87.927,87.927c0,48.483,39.444,87.926,87.927,87.926 c48.482,0,87.927-39.443,87.927-87.926C343.926,175.757,304.482,136.314,255.999,136.314z M255.999,296.179 c-39.668,0-71.94-32.273-71.94-71.939c0-39.668,32.273-71.94,71.94-71.94c39.668,0,71.94,32.273,71.94,71.94 C327.94,263.907,295.667,296.179,255.999,296.179z",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("path", {
              attrs: {
                d: "M216.669,239.933v7.858h0c0,22.708,17.107,39.832,39.813,39.832c22.708,0,39.815-17.124,39.815-39.832v-7.858H216.669z M255.999,271.907c-11.185,0-19.914-6.498-22.953-16.258h45.907C275.914,265.408,267.184,271.907,255.999,271.907z",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("rect", {
              attrs: {
                x: "215.626",
                y: "184.403",
                width: "15.716",
                height: "15.716",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("rect", {
              attrs: {
                x: "280.586",
                y: "184.403",
                width: "15.716",
                height: "15.716",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("rect", {
              attrs: {
                x: "32.266",
                y: "376.14",
                width: "15.716",
                height: "15.716",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("rect", {
              attrs: {
                x: "64.746",
                y: "376.14",
                width: "15.716",
                height: "15.716",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("rect", {
              attrs: {
                x: "96.183",
                y: "376.14",
                width: "15.716",
                height: "15.716",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("rect", {
              attrs: {
                x: "400.029",
                y: "376.14",
                width: "15.716",
                height: "15.716",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("rect", {
              attrs: {
                x: "431.461",
                y: "376.14",
                width: "15.716",
                height: "15.716",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("rect", {
              attrs: {
                x: "463.941",
                y: "376.14",
                width: "15.716",
                height: "15.716",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("path", {
              attrs: {
                d: "M319.946,472.033v-47.959H303.96v47.959c0,8.989,2.984,17.296,8.011,23.981H208.019 c5.029-6.685,8.013-14.992,8.013-23.981v-47.959h-15.986v47.959c0,13.223-10.758,23.981-23.981,23.981h-7.993V512h175.853v-15.986 C330.704,496.014,319.946,485.256,319.946,472.033z",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("rect", {
              attrs: {
                x: "231.342",
                y: "464.151",
                width: "56.578",
                height: "15.716",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("rect", {
              attrs: {
                x: "247.058",
                y: "72.294",
                width: "17.812",
                height: "15.716",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("rect", {
              attrs: {
                x: "239.724",
                y: "49.244",
                width: "32.48",
                height: "15.716",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("rect", {
              attrs: {
                x: "224.008",
                y: "24.098",
                width: "63.912",
                height: "15.716",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("rect", {
              attrs: { x: "208.291", width: "95.345", height: "15.716" },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("path", {
              attrs: {
                d: "M383.892,184.274v151.873h95.92V184.274H383.892z M463.826,320.16h-63.947v-119.9h63.947V320.16z",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("rect", {
              attrs: {
                x: "415.745",
                y: "215.835",
                width: "31.432",
                height: "15.716",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("rect", {
              attrs: {
                x: "415.745",
                y: "239.933",
                width: "31.432",
                height: "15.716",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("rect", {
              attrs: {
                x: "415.745",
                y: "265.079",
                width: "31.432",
                height: "15.716",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("rect", {
              attrs: {
                x: "415.745",
                y: "288.13",
                width: "31.432",
                height: "15.716",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("polygon", {
              attrs: {
                points:
                  "32.266,127.825 32.266,208.501 47.982,208.501 47.982,143.541 87.797,143.541 87.797,127.825 ",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("rect", {
              attrs: {
                x: "32.266",
                y: "224.217",
                width: "15.716",
                height: "15.716",
              },
            }),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }